<template>
  <popup v-model="visible" size="sm" class="popup-flexible-cancellation">
    <div class="popup-flexible-cancellation__title font-h1 u-text-center">
      {{ $t("popupFlexibleCancellation.title") }}
    </div>
    <list-markered
      :items="$t('popupFlexibleCancellation.list')"
      class="popup-flexible-cancellation__list"
    >
      <template #marker>
        <div class="popup-flexible-cancellation__list-marker">
          <svg-inline class="u-text-secondary">
            <icon icon="checkmark-circle-outline" />
          </svg-inline>
        </div>
      </template>
    </list-markered>
    <div class="popup-flexible-cancellation__accept">
      <Button
        type="button"
        tag="button"
        color="gray"
        class="popup-flexible-cancellation__accept-button"
        @click="visible = false"
      >
        {{ $t("popupFlexibleCancellation.accept") }}
      </Button>
    </div>
  </popup>
</template>

<script>
import Popup from "@/components/ui-kit/popup/index.vue";
import ListMarkered from "@/components/ui-kit/list-markered/index.vue";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";
import Button from "@/components/ui-kit/button/index.vue";

export default {
  components: {
    Popup,
    ListMarkered,
    SvgInline,
    Icon,
    Button,
  },
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("change", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.popup-flexible-cancellation {
  &__title {
    margin-bottom: 27px;
  }

  &__list {
    margin-bottom: 32px;

    &-marker {
      width: 18px;
    }
  }

  &__accept {
    &-button {
      width: 100%;
    }
  }
}
</style>
